import React, { useState, useContext, useEffect } from 'react'
import PropTypes from 'prop-types'

import { MProductItem, EcommercePage } from '../../common/ecommerce'
import { MTicketAccessCode } from '../types'

import { PASSWORD, PasswordContext } from '../contexts/PasswordContext'
import { PRODUCTS, ProductContext } from "../../common/ecommerce/contexts/Product"
import { CHECKOUT, CheckoutContext } from '../../common/ecommerce/contexts/Checkout'

import { searchTicketAccessCode } from '../api/ticketAccessCodes'

const TICKET_VALID_NAME = 'VSFTicketPassValid'
const TESTING_FLAG = false

const EcommercePasswordPage = ({products, accessCode, ...rest}) => {
  const { checkoutUpdate } = useContext(CheckoutContext)
  const { dispatch } = useContext(ProductContext)

  const {passwordState: { valid }, passwordUpdate} = useContext(PasswordContext)
  const [password, setPassword] = useState("")
  const [error, setError] = useState(false)
  const [show, setShow] = useState(false)
  const _setTicketAccessCode = (value) => checkoutUpdate({ type: CHECKOUT.TICKET_ACCESS_CODE, payload: value})
  const _setDestination = (payload) =>
    dispatch({ type: PRODUCTS.FILTERS.DESTINATION, payload })


  useEffect(
    () => {
      if (accessCode) {
        _assignValidPassword(accessCode)
        return
      }

      if (localStorage.getItem(TICKET_VALID_NAME)) {
        let storageObject = JSON.parse(localStorage.getItem(TICKET_VALID_NAME))
        if ((new Date(storageObject.expiresAt) >= new Date()) && (storageObject.accessCode)) {
          _setTicketAccessCode(storageObject.accessCode)
          _setValidPassword()
        } else {
          _removeLocalStorage()
          _setInValidPassword()
        }
      }

      if(TESTING_FLAG) {
        _removeLocalStorage()
        _setInValidPassword()
      }
    }
  , [])

  const _handlePasswordEntry = (e) => {
    let value = e.currentTarget.value
    setPassword(value.replace(/\W/g, ''))
  }

  const _handleSubmit = (e) => {
    e.preventDefault()
    searchTicketAccessCode(password).then((response) => {
      _assignValidPassword(response.data)
    }).catch((error) => {
      setError(true)
      _removeLocalStorage()
      _setTicketAccessCode(undefined)
      _setInValidPassword()
    })
  }

  const _assignValidPassword = (accessCode) => {
    _setTicketAccessCode(accessCode.access_code)
    if (accessCode.destination_name) {
      _setDestination({ label: accessCode.destination_name, value: accessCode.destination_name})
    }
    _setValidPassword()
    _setLocalStorage(accessCode)
  }

  const _setValidPassword = () => passwordUpdate({type: PASSWORD.VALID.SET, payload: true})
  const _setInValidPassword = () => passwordUpdate({type: PASSWORD.VALID.SET, payload: false})

  const _setLocalStorage = (accessCode) => {
    if (accessCode['public_pricing'])
      return
    let expiresDate = new Date()
    expiresDate.setDate(expiresDate.getDate() + 1)
    let storageObject = {
      expiresAt: expiresDate,
      valid: 'valid',
      accessCode: accessCode.access_code,
      destinationName: accessCode.destination_name
    }
    localStorage.setItem(TICKET_VALID_NAME, JSON.stringify(storageObject))
  }

  const _removeLocalStorage = () => localStorage.removeItem(TICKET_VALID_NAME)

  const _renderError = () => (
    <div className="error alert">
      The access code you entered is not correct, please try again
    </div>
  )

  const _togglePasswordVisibility = (e) => {
    e.preventDefault()
    setShow(!show)
  }

  const _renderPasswordContent = () => {
    return (
      <section
        className="tickets-protect-page white-content-box"
        >
        <div className="pad-me">
          <h2>Members Only</h2>
          {
            error && _renderError()
          }
          <form onSubmit={_handleSubmit}>
            <div className="form-group">
              <div className="form-group">
                <input
                  type={show ? "text" : "password"}
                  value={password}
                  placeholder="Enter your access code"
                  autoComplete="new-password"
                  onChange={_handlePasswordEntry}
                  className={`form-control ${error ? 'error' : ''}`}
                  />
                <button
                  className   = "toggle-password-visibility"
                  onClick     = {_togglePasswordVisibility}
                  type        = "button"
                  role        = "button"
                  aria-label  = "Toggle the password visibility"
                  >
                  <i className={`fas ${show ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                </button>
              </div>
              <button
                type="submit"
                className="btn btn-primary grad blue"
                role="button"
                aria-label = "Continue with access code"
                >
                  Continue
                </button>
            </div>
          </form>
          <a className="btn btn-secondary grad no-access-code" href="/ticketstore">I don&apos;t have an access code</a>
          <div className="notes">
            <p>If you haven&apos;t received an access code or have no idea why you need an access code, please contact us.</p>
            <p>If you have forgotten your access code, please check your email or contact us.</p>
            <h4>Phone: <a href="tel:1-877-218-8232">1-877-218-8232</a></h4>
            <h4>Email: help@vacationoffer.com</h4>
          </div>
        </div>
      </section>
    )
  }

  return (
    <React.Fragment>
      {
        !valid && _renderPasswordContent()
      }
      {
        valid && <EcommercePage products={products} {...rest} />
      }
    </React.Fragment>
  )
}

EcommercePasswordPage.propTypes = {
  products: PropTypes.arrayOf(MProductItem),
  accessCode: MTicketAccessCode,
}

export default EcommercePasswordPage
